import { useState, ChangeEvent, FocusEvent } from 'react';

import { PasswordControlProps } from 'app/components/Controls/PasswordControl/PasswordControl.interfaces';

export function usePasswordControl({
  input,
  meta: { touched, valid },
  onClick,
  onControlBlur,
  onValueChange,
  setIsValueTooLong,
}: PasswordControlProps) {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const error = touched && !valid;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (value.length > 70) {
      setIsValueTooLong && setIsValueTooLong(true);
      return;
    } else {
      setIsValueTooLong && setIsValueTooLong(false);
    }

    input.onChange(value);

    if (onValueChange) {
      onValueChange(value, false, false);
    }
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    setFocused(false);

    input.onBlur(event.target.value);

    if (onControlBlur) {
      const shouldPatch = false;
      onControlBlur(shouldPatch);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return {
    error,
    focused,
    setFocused,
    handleBlur,
    handleChange,
    handleClick,
    toggleShowPassword,
    showPassword,
  };
}
